export const BEHAVIOURS_LABEL: { [key: number]: string } = {
  0: 'Finalizar atendimento',
  1: 'Desabilitar cliente',
  2: 'Aguardando resposta',
  3: 'Avançar no funil',
  4: 'Fechar contrato',
};